//React
import React from 'react';
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as searchAction from '../action/searchAction';

//Func
import { lsSearchDisplayInit } from '../func/lsSearchDisplay';
//Material-ui
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
//Part
import PartCheckbox from './PartCheckbox';
//Add
//Icon
import CloseIcon from '@material-ui/icons/Close';

const displayItem = [
  {"ja":"コメント", "en":"comment"},
  {"ja":"足あと", "en":"footprint"},
  {"ja":"身長", "en":"height"},
  {"ja":"学歴", "en":"academic"},
  {"ja":"仕事", "en":"job"},
  {"ja":"年収", "en":"income"},
  {"ja":"体型", "en":"style"},
  {"ja":"交際希望", "en":"association"},
  {"ja":"結婚歴", "en":"marriage"},
  {"ja":"子供", "en":"child"},
  {"ja":"生活", "en":"lifestyle"},
  {"ja":"タバコ", "en":"smorking"},
  {"ja":"お酒", "en":"drinking"},
  {"ja":"ギャンブル", "en":"gambling"},
  {"ja":"ペット", "en":"pet"},
  {"ja":"休日", "en":"holiday"},
  {"ja":"メモ", "en":"memo"}
]

class Comp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      display: [],
  	}
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.open === false && this.props.open === true) {
      this.setState({
        display: localStorage.getItem('SearchDisplay').split(','),
      });
    }
  }

  _resetSubmit() {
    lsSearchDisplayInit();
    this.props.onClose();
  }

  _checkboxChange(value) {
    let display = [];
    if (!this.state.display.includes(value)) {
      display = [...this.state.display, value];
		}
    else {
      display = this.state.display.filter((arr) => { return arr !== value });
		}
    this.setState({
      display: display,
    });
    localStorage.setItem('SearchDisplay', display);
  }


	render() {
		return (
			<Dialog
        open={this.props.open}
        maxWidth='xs'
        onClose={ () => this.props.onClose() }
      >
        <div
          style={{
            display:'flex',
            flexDirection:'row',
            textAlign:'center',
            alignItems:'center',
            justifyContent:'space-between',
          }}
        >
          <div style={{fontSize:'1.1em',fontWeight:'bold',margin:'15px'}}>
            表示項目
          </div>
          <div>
            <IconButton onClick={ () => this.props.onClose() }>
              <CloseIcon />
            </IconButton>
          </div>
        </div>
        <div style={{padding:'10px'}}>
          <div style={{color:'#666'}}>検索結果の一覧に表示する項目を選択してください</div>
          {
            displayItem.map((value, index) =>
              <PartCheckbox
                key={index}
                value={value.en}
                checked={this.state.display.includes(value.en)}
                click={ (e) => this._checkboxChange(e) }
              >
                <span>{value.ja}</span>
              </PartCheckbox>
            )
          }
          <div align='right'>
            <Button
              variant="outlined"
              color='primary'
              onClick={ () => this._resetSubmit() }
            >
              リセット
            </Button>
          </div>
        </div>

			</Dialog>
		)
	}
}

const mapStateToProps = (state) => {
	return {
    search: state.search,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...searchAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
